import {css, StyleSheet, CSSProperties} from 'aphrodite';
import React, {ReactNode} from 'react';

import {GRAY_LIGHT} from 'ui-library/Colors';

interface StickyFooterProps {
  children: ReactNode;
}

export default function StickyFooter({children}: StickyFooterProps): JSX.Element {
  return <div className={css(styles.stickyFooter)}>{children}</div>;
}

/**
 * Container styles required for the sticky footer to work properly.
 * Apply these to the outermost container that wraps both content and StickyFooter.
 */
export const STICKY_FOOTER_CONTAINER_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  justifyContent: 'space-between',
} satisfies CSSProperties;

/**
 * Content styles for the scrollable content area above the sticky footer.
 * Apply these to the container that holds your main content.
 */
export const STICKY_FOOTER_CONTENT_STYLES = {
  flex: '1 1 auto',
  overflow: 'auto',
} satisfies CSSProperties;

const styles = StyleSheet.create({
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
    borderTop: `1px solid ${GRAY_LIGHT}`,
    marginTop: '80px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '16px',
    gap: '16px',
  },
});
